import { Component, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { switchMap } from 'rxjs';

@Component({
    template: '',
    standalone: false
})
export class AcceptInvitationComponent {

  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  constructor() {
    // Redirect to Auth0's authorize endpoint with invitation details if present
    this.route.queryParamMap.pipe(
      switchMap(params => {
        if (params.has('invitation') && params.has('organization')) {
          return this.authService.loginWithRedirect({
            authorizationParams: {
              invitation: params.get('invitation'),
              organization: params.get('organization')
            }
          });
        } else {
          // If no invitation information can be found, redirect to home
          return this.router.navigate(['/']);
        }
      }),
      takeUntilDestroyed(this.destroyRef)
    )
      .subscribe();
  }
}
